import React from "react";
import PropertyListing from "../../../stories/property-list/property-listing";
import styles from "./index.module.scss";
import { useInvestorPropertyList } from "../../../hooks/react-query/investor/useInvestorPropertyList";
import { useMapInvestorPropertyList } from "../../../hooks/react-query/investor/useMapInvestorPropertyList";

export default function PropertiesListing() {
  const {
    arrProperty,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isPlaceholderData,
    isFetchingNextPage
  } = useInvestorPropertyList({ type: "investor" });
  const { arrMapProperty } = useMapInvestorPropertyList({ type: "investor" });

  return (
    <div className={styles.propertyList}>
      <div className={styles.content}>
        <PropertyListing
          type="investor"
          arrMapProperty={arrMapProperty}
          arrProperty={arrProperty}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          isLoading={isLoading}
          isPlaceholderData={isPlaceholderData}
          isFetchingNextPag={isFetchingNextPage}
        />
      </div>
    </div>
  );
}
